module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-11-56245cf739de900e1730d64ac78b7035.webp";